import { Injectable } from "@angular/core";
import { containerLoad } from "./load-types.const";
import { containerLoadPointer } from "./container-load-pointers";

export const getLocationTermsListPointer = (
  containerLoadParam: string,
): string => {
  if (containerLoadParam === containerLoad.fcl) {
    return containerLoadPointer.locationTermsListFcl;
  }
  if (containerLoadParam === containerLoad.lcl) {
    return containerLoadPointer.locationTermsListLcl;
  }
  if (containerLoadParam === containerLoad.air) {
    return containerLoadPointer.locationTermsListAir;
  }
  if (containerLoadParam === containerLoad.ltl) {
    return containerLoadPointer.locationTermsListLtl;
  }
};

export const getLocationTermsModelPointer = (
  containerLoadParam: string,
): string => {
  if (containerLoadParam === containerLoad.fcl) {
    return containerLoadPointer.locationTermsModelFcl;
  }
  if (containerLoadParam === containerLoad.lcl) {
    return containerLoadPointer.locationTermsModelLcl;
  }
  if (containerLoadParam === containerLoad.air) {
    return containerLoadPointer.locationTermsModelAir;
  }
  if (containerLoadParam === containerLoad.ltl) {
    return containerLoadPointer.locationTermsModelLtl;
  }
};

@Injectable()
export class ContainerLoadService {
  public getLocationTermsListPointer = getLocationTermsListPointer;
  public getLocationTermsModelPointer = getLocationTermsModelPointer;

  constructor() {}
}
